import React from "react";
import { useTheme } from "../ThemeProvider";
import "./embed.css";
import Header from "../components/header/mainHeader.js";
import Footer from "../components/footer/mainFooter.js";
import SingleUsecaseCall from "../singleUsecase/singleUsecaseCall/singleUsecaseCall.js";
import SingleUsecaseHero from "../singleUsecase/singleUsecaseHero/singleUsecaseHero.js";
import SingleUsecaseDescription from "../singleUsecase/singleUsecaseDescription/singleUsecaseDescription.js";
import SingleUsecasePhoto from "../singleUsecase/singleUsecasePhoto/singleUsecasePhoto.js";

import a from "../assets/gabrila/01.webp";
import b from "../assets/gabrila/02.webp";
import c from "../assets/gabrila/03.webp";
import d from "../assets/gabrila/04.webp";
import e from "../assets/gabrila/05.webp";

function FashionGabriela() {
  const { theme } = useTheme();

  document.title = "3VO | Fashion Gabriela";

  return (
    <div className={`subpage ${theme === "light" ? "" : "dark-theme"}`}>
      <Header />
      <SingleUsecaseHero title="Fashion Gabriela" subtitle="" />

      <SingleUsecasePhoto img={a} name="Fashion Gabriela" />
      <SingleUsecasePhoto img={b} name="Fashion Gabriela" />
      <SingleUsecasePhoto img={c} name="Fashion Gabriela" />
      <SingleUsecasePhoto img={d} name="Fashion Gabriela" />
      <SingleUsecasePhoto img={e} name="Fashion Gabriela" />
      <SingleUsecaseCall />
      <Footer />
    </div>
  );
}

export default FashionGabriela;
